
import { Menu, Button, Modal, Skeleton } from "antd";
import { useState, useContext, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { QuestionCircleFilled } from '@ant-design/icons';
import moment from "moment";
import { Constant } from "../../constants/conts";
import logo from "../../assets/images/logo.png";

export const menuItems = [
  {
    key: "Dashboard",
    path: "/dashboard",
    icon: "fas fa-tachometer-alt",
    label: "Dashboard"
  },
  {
    key: "UserSection",
    path: "/user",
    icon: "fas fa-users",
    label: "User Manager"
  },
  {
    key: "CategorySection",
    path: "/category",
    label: "Category Manager",
    icon: "fa-solid fa-layer-group",
  },
  {
    key: "ClusterMenu",
    path: "/cluster",
    label: "Cluster Manager",
    icon: "fab fa-skyatlas",
  },
  {
    key: "TagMenu",
    path: "/tag",
    label: "Tag Manager",
    icon: "fas fa-tag",
  },
  {
    key: "CityMenu",
    path: "/city",
    label: "City Manager",
    icon: "fa-solid fa-tree-city",
  },
  {
    key: "BrandMenu",
    path: "/brand",
    label: "Brand Manager",
    icon: "fa-solid fa-shop",
  },
  {
    key: "ReferralMenu",
    path: "/referral",
    label: "Referral Manager",
    icon: "fa-solid fa-share-nodes",
  },
  {
    key: "CmsMenu",
    path: "/cms",
    label: "CMS Manager",
    icon: "fa-solid fa-list",
  },
  /* {
    key: "ServiceSection",
    path: "/service",
    icon: "fa-solid fa-people-carry-box",
    label: "Service / Product Manager"
  }, */
]

function Sidenav({ color }) {

  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const { userProfile, logout, setUserProfile } = useContext(AuthContext)
  const { confirm } = Modal;
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [menuLinks, setMenuLinks] = useState([]);
  const [menuMode, setMenuMode] = useState('vertical');
  const [currentDateTime, setCurrentDateTime] = useState(moment());

  const showDeleteConfirm = (record) => {
    setTimeout(() => {
      confirm({
        okText: 'Logout',
        okType: 'danger',
        icon: <QuestionCircleFilled />,
        cancelText: 'Cancel',
        content: <Button >Are you sure you want to logout ?</Button>,
        onOk() {
          logout();
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }, 5);
  };

  const renderTitle = (item) => {
    return (
      <>
        <span className="icon"><i className={item.icon}></i></span>
        <span className="label">{item.label}</span>
      </>
    )
  }

  useEffect(() => {
    setLoading(true)
    if (!userProfile) return
    if (userProfile.user_type == 'Admin') {
      setMenuLinks(menuItems)
      setLoading(false)
      return
    }
    const newArray = menuItems.filter(item => {
      if (item.children) {
        item.children = item.children.filter(child => userProfile.permission?.hasOwnProperty(child.key));
      } else {
        return userProfile.permission?.hasOwnProperty(item.key)
      }
      return item
    });

    const links = newArray.filter(item => {
      if (item?.children?.length) {
        return true
      } else if (!item?.children) {
        return true
      } else {
        return false
      }
    })
    setMenuLinks(links)
  }, [userProfile])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMenuMode('inline');
      } else {
        setMenuMode('vertical');
      }
    }

    window.addEventListener('resize', handleResize);

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>

      <img src={logo} className="logo" />
      
      {/* <div className="brand w-100">
        <NavLink to="/dashboard" className="imgOuter"> {Constant.PROJECT_NAME} </NavLink>
      </div> */}
        
      <p className="text-center mt-1">Current Time : {currentDateTime.format("YYYY-MM-DD hh:mm A")}</p>

      {
        loading ? [1, 2, 3, 4, 5, 6].map(item => <Skeleton active key={item} />)
          :
          <Menu inlineCollapsed={false} mode={menuMode} className="sideNavMain">
            {menuLinks.map(item => {
              if (item.children) {
                return (
                  <Menu.SubMenu key={item.key} title={<>
                    <span className="icon"><i className={item.icon}></i></span>
                    <span className="label">{item.label}</span>
                  </>}>
                    {item.children.map(child => (
                      <Menu.Item key={child.key}>
                        <NavLink to={child.path}>{child.label}</NavLink>
                      </Menu.Item>
                    ))}
                  </Menu.SubMenu>
                );
              }

              return (
                <Menu.Item key={item.key}>
                  <NavLink to={item.path}>
                    {renderTitle(item)}
                  </NavLink>
                </Menu.Item>
              );
            })}


            <Menu.Item >
              <a onClick={showDeleteConfirm}>
                <>
                  <span className="icon"><i className="fas fa-sign-out-alt"></i></span>
                  <span className="label">Logout </span>
                </>
              </a>
            </Menu.Item>

          </Menu>
      }

    </>
  );

}

export default Sidenav;
